// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InviteUsersQuestProgress_wrapper_2E__1","title":"InviteUsersQuestProgress_title_1bSXY","completed":"InviteUsersQuestProgress_completed_1kX8z"};